import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Checkbox } from '../../components/ui/checkbox';
import { Mail, MessageSquare } from 'lucide-react';

/** Email + SMS receipt opt-ins. */
export const POSReceiptOptions = ({ receipts, customerPhone }) => (
  <>
    <div className="space-y-2 rounded-lg border bg-muted/30 p-3">
      <div className="flex items-center gap-2">
        <Checkbox
          id="email-receipt-checkbox"
          checked={receipts.emailReceipt}
          onCheckedChange={(v) => receipts.setEmailReceipt(!!v)}
          data-testid="email-receipt-checkbox"
        />
        <Label htmlFor="email-receipt-checkbox" className="flex items-center gap-1.5 cursor-pointer text-sm">
          <Mail className="h-3.5 w-3.5 text-primary" /> Email branded receipt to customer
        </Label>
      </div>
      {receipts.emailReceipt && (
        <Input
          type="email"
          value={receipts.customerEmail}
          onChange={(e) => receipts.setCustomerEmail(e.target.value)}
          placeholder="customer@example.com"
          className="h-9 text-sm"
          data-testid="customer-email-input"
        />
      )}
      {receipts.emailReceipt && !receipts.customerEmail && (
        <p className="text-[11px] text-muted-foreground">A PDF receipt will be sent right after the sale completes.</p>
      )}
    </div>

    <div className="space-y-2 rounded-lg border bg-muted/30 p-3">
      <div className="flex items-center gap-2">
        <Checkbox
          id="sms-receipt-checkbox"
          checked={receipts.smsReceipt}
          onCheckedChange={(v) => receipts.setSmsReceipt(!!v)}
          data-testid="sms-receipt-checkbox"
        />
        <Label htmlFor="sms-receipt-checkbox" className="flex items-center gap-1.5 cursor-pointer text-sm">
          <MessageSquare className="h-3.5 w-3.5 text-primary" /> SMS receipt to customer
        </Label>
      </div>
      {receipts.smsReceipt && !customerPhone && (
        <p className="text-[11px] text-amber-600 dark:text-amber-500">
          Add a phone number above (Ghana format like 0244111222) — SMS will be sent right after the sale.
        </p>
      )}
      {receipts.smsReceipt && customerPhone && (
        <p className="text-[11px] text-muted-foreground">
          Will text {customerPhone} via your Arkesel sender ID.
        </p>
      )}
    </div>
  </>
);
